<template>
<div>

<ContentOverlay></ContentOverlay>


<div class="content_card" v-if="!$store.state.ui.contentframeloading">
<ContentHeader :title="$store.state.languages.lang_phrases.tedarikci_kartlari"  :show_button="false" ></ContentHeader>


<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>



<div class="content_card_content" v-if="!loading">


<template v-if="!data.length">
<div class="flex align-items-center justify-content-center mb-8 mt-8">
<h3 class="text-primary font-medium">{{$store.state.languages.lang_phrases.henuz_hic_kayit_olusturulmamis}}</h3>

</div>
</template>

<template v-else>
<ContentTable :data="data" :columns="columns" routename="Suppliercard"  @dataDeleted="getData" identifier_row="id" identifier_row_name="card_id"></ContentTable>
</template>


</div>





</div>







</div>
</template>
<script>
export default {

  name: 'SupplierCards',

   data () {
     return {
      data:[],
      loading:true,
      columns:[  
      {
        type:"text",
        field:"card_name",        
        with_route:true,
        header:"isim",
        hide_on_mobile:false,
        multilingual:true
      },
      ]
    }
  },
   mounted()
  {
  	//this.$store.dispatch('ui/setActiveTab',"projeler") 
    //console.log(this.$route.params)
  	this.getData()
  },
  methods:{
    orderProjects(a, b )
    {
       if ( a.project.queue < b.project.queue ){
        return -1;
      }
      if ( a.project.queue > b.project.queue ){
        return 1;
      }
      return 0;

    },
  	async getData()
  	{
      this.loading = await true
      //await console.log(this.$store.state.auth.user)
  		let data = await this.generalApiGetWithoutLoader("get_supplier_brand_scorecards/"+this.$route.params.supplier_uuid+"/supplier") 
      console.log("data")
      console.log(data)

      for(let item of data)
      {
      	let card_name = await item.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
      	if( item.translations.length)
        {
            item.card_name = await item.translations
        }
      }
      
      this.data = await data
      this.loading = await false
      await console.log(this.data);
  	},
  	
  }
};
</script>

<style lang="css" scoped>
</style>